<template>
  <div
    @click="lockToggle"
    class="ag-cell-label-container"
    role="presentation"
  >
    <span
      ref="eMenu"
      class="ag-header-icon ag-header-cell-menu-button"
    />
    <div
      ref="eLabel"
      class="ag-header-cell-label"
      role="presentation"
    >
      <span
        v-if="locked"
        class="material-icons-outlined"
        title="Click here to unlock all"
      >
        {{ 'lock' }}
      </span>
      <span
        v-if="!locked"
        class="material-icons-outlined"
        title="Click here to lock all"
      >
        {{ 'lock_open' }}
      </span>
      <span> {{ title }}</span>
      <span
        ref="eSortOrder"
        class="ag-header-icon ag-sort-order"
      />
      <span
        ref="eSortAsc"
        class="ag-header-icon ag-sort-ascending-icon"
      />
      <span
        ref="eSortDesc"
        class="ag-header-icon ag-sort-descending-icon"
      />
      <span
        ref="eSortNone"
        class="ag-header-icon ag-sort-none-icon"
      />
      <span
        ref="eText"
        class="ag-header-cell-text"
        role="columnheader"
      />
      <span
        ref="eFilter"
        class="ag-header-icon ag-filter-icon"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { computed, ref, toRefs } from 'vue';
  import { ExperianCodedHeaderParams } from '@/app/shared/types/grid-cells/experian-coded-header-params.interface';
  import { AtbError } from '@/app/shared/types/errors/error.interface';
  import { useAlertStore } from '@/app/shared/stores/alert-store';
  import { Motif } from '@/app/shared/enums/motif-enum';

  interface ExperianCodedHeaderColumnProps {
    params: ExperianCodedHeaderParams;
  }
  const props = defineProps<ExperianCodedHeaderColumnProps>();
  const { params } = toRefs(props);
  const title = computed(() => params.value.dataSourceName);
  const locked = ref(false);
  const alertStore = useAlertStore();

  const lockToggle = async () => {
    if (!locked.value) {
      try {
        params.value.lockAll(params.value.dataSourceName);
        locked.value = !locked.value;
        setTimeout(() => {
          params.value?.api.refreshInfiniteCache();
        }, 1000);
      } catch (error) {
        const message = error as AtbError;
        alertStore.showNotification(
          message?.errors?.[0].error || 'Unkown error returned from server',
          'Filters',
          Motif.ERROR
        );
      }
    } else {
      try {
        params.value.unlockAll(params.value.dataSourceName);
        locked.value = !locked.value;
        setTimeout(() => {
          params.value?.api.refreshInfiniteCache();
        }, 1000);
      } catch (error) {
        const message = error as AtbError;
        alertStore.showNotification(
          message?.errors?.[0].error || 'Unkown error returned from server',
          'Filters',
          Motif.ERROR
        );
      }
    }
  };
</script>
